import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClose,
  faEdit,
  faEllipsisV,
  faEye,
  faFilePdf,
  faHome,
  faL,
  faPlug,
  faPlus,
  faTrash,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import {
  Badge,
  Breadcrumb,
  Button,
  Card,
  Form,
  Table,
} from "@themesberg/react-bootstrap";
import {
  confirmDeleteToast,
  sendError,
  sendSuccess,
  status,
} from "../helpers/Helper";
import { API_URL_ENDPOINT, BUSSINESS_NAME } from "../appsetting";
import CustomPagination from "../components/CustomPagination";
import { useNavigate } from "react-router-dom";
import { Routess } from "../Routes/routes";
import { Avatar } from "@mui/material";
import { useApi, useHasPermission } from "../helpers/useApi";
import { Model } from "../components/Model";
import { SelectBox } from "../components/SelectBox";
import { Textbox } from "../components/Textbox";
import OffCanvas from "../components/OffCanvas";
import BiltyComponent from "../components/Bilty";
import Permissions from "../Routes/permissions";
import { useAuth } from "../store/AuthContext";
import { Dropdown, Spinner } from "react-bootstrap";
import ActionMenu from "../components/ActionMenu";
import PageLoader from "../components/PageLoader";

export const BiltyList = () => {
  const { user, logout } = useAuth();
  const callApi = useApi();
  const hasPermission = useHasPermission();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const [isSubmittingBtn, setIsSubmittingBtn] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [biltyEdit, setBiltyEdit] = useState(0);

  const userCompany = user["CompanyID"];
  const methods = useForm();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
    watch,
    setValue,
  } = methods;

  const [addBiltyModel, setAddBiltyModel] = useState(false);
  const [states, setStates] = useState({
    items: [],
    pageNo: 1,
    pageSize: 50,
    totalPage: 0,
    totalRecords: 0,
  });

  const [city, setCity] = useState({
    items: [],
    pageNo: 1,
    pageSize: 50,
    totalPage: 0,
    totalRecords: 0,
  });

  const [dataLoading, setDataLoading] = useState(false);
  const [data, setData] = useState({
    items: [],
    pageNo: 1,
    pageSize: 10,
    totalPage: 0,
    totalRecords: 0,
  });

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    const delay = setTimeout(() => {
      if (isTyping) {
        setIsTyping(false);
        getData(1);
      }
    }, 300);

    return () => clearTimeout(delay);
  }, [searchTerm]);

  const handlePageChange = (newPage) => {
    getData(newPage);
  };

  const getData = async (cp = null) => {
    try {
      setDataLoading(true);
      const filters = [];
      if (searchTerm) filters.push(`SearchText:${searchTerm}`);
      const queryParams = [
        filters.length ? `filters=${filters.join(",")}` : null,
        `pageNo=${cp ?? data.pageNo}`,
        `pageSize=${data.pageSize}`,
        `sortOrder=desc`,
      ]
        .filter(Boolean)
        .join("&");

      const response = await callApi(
        API_URL_ENDPOINT.Bilty + `?${queryParams}`
      );
      if (response.status) {
        setData(response.data);
      }
    } catch {
      setData({
        items: [],
        pageNo: 1,
        pageSize: 10,
        totalPage: 0,
        totalRecords: 0,
      });
    } finally {
      setDataLoading(false);
    }
  };

  const GenerateBilty = async (id, isPreview = true) => {
    try {
      setIsSubmittingBtn(true);
      setPageLoading(true)
      if (isPreview) {
        const token = localStorage.getItem(BUSSINESS_NAME + '_token');
        // Use fetch directly for blob response
        const response = await fetch(
          `${API_URL_ENDPOINT.Bilty}/pdf/${id}?isPreview=true`,
          {
            method: "GET",
            headers : {
              Authorization: `Bearer ${token}`
            }
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch PDF");
        }
        console.log(response.headers.get("Content-Type"));
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");
      } else {
        // Use your normal callApi for JSON response
        const response = await callApi(
          `${API_URL_ENDPOINT.Bilty}/pdf/${id}?isPreview=false`
        );

        if (response.status) {
          // Update frontend state
          setData((prevData) => {
            const updatedItems = prevData.items.map((item) => {
              if (item.id === id) {
                return {
                  ...item,
                  isBiltyGenrated: true,
                  biltyPath: response.data?.documentURL || null,
                };
              }
              return item;
            });

            return {
              ...prevData,
              items: updatedItems,
            };
          });
          sendSuccess("Bilty Generated Successfully");
        } else {
          throw new Error(response.message || "Something went wrong.");
        }
      }
    } catch (ex) {
      console.error(ex.message);
      sendError(ex.message || "Something went wrong.");
    }
    finally{
      setIsSubmittingBtn(false);
      setPageLoading(false)
    }
  };

  const handleDelete = () => {
    confirmDeleteToast(() => {
      sendSuccess("Deleted successfully!");
    });
  };

  const onBiltyCreated = () => {
    setBiltyEdit(0);
    setAddBiltyModel(false);
    getData();
  };

  return (
    <>
      <OffCanvas
        show={addBiltyModel}
        placement="end"
        handleClose={() => {setAddBiltyModel(false);setBiltyEdit(0);}}
        width="100%"
        title={"Genrate Bilty"}
      >
        <BiltyComponent onBiltyCreated={onBiltyCreated} biltyID={biltyEdit} />
      </OffCanvas>
      

      <PageLoader show={pageLoading}/>
      <div className="justify-content-between d-flex flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
          >
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            {/* <Breadcrumb.Item>NPSP</Breadcrumb.Item> */}
            <Breadcrumb.Item active>Bilty</Breadcrumb.Item>
          </Breadcrumb>
          <div className="d-flex align-items-center justify-content-between">
            <h4 className="mb-0">Bilty</h4>
          </div>
        </div>
        <div className="d-flex align-items-center">
          {hasPermission(Permissions.Bilty.Create) && userCompany && (
            <Button
              onClick={() => setAddBiltyModel(true)}
              className="me-2 d-block"
              variant="primary"
              style={{ whiteSpace: "nowrap" }}
            >
              <FontAwesomeIcon icon={faPlus} /> Add Bilty
            </Button>
          )}

          <Form.Control
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setIsTyping(true);
            }}
            type="text"
            className="shadow-none"
            placeholder={"Search..."}
          />
        </div>
      </div>

      <Card border="light" className="shadow-sm mb-4">
        <Card.Body className="pb-0">
          {dataLoading ? (
            <div className="text-center my-3">
              <span
                className="spinner-border text-primary"
                role="status"
              ></span>
            </div>
          ) : (
            <Table
              responsive
              className="table-centered table-nowrap rounded mb-0"
            >
              <thead className="thead-light">
                <tr>
                  <th className="border-0 text-center">#</th>
                  <th className="border-0 text-center">Bilty Number</th>
                  <th className="border-0 text-center">Date</th>
                  <th className="border-0 text-center">Vehicle Number</th>
                  <th className="border-0 text-center">From</th>
                  <th className="border-0 text-center">To</th>
                  <th className="border-0 text-center">Consignor</th>
                  <th className="border-0 text-center">Consignee</th>
                  <th className="border-0 text-center">Total Amount</th>
                  <th className="border-0 text-center">Status</th>
                  <th className="border-0 text-end pe-4">Action</th>
                </tr>
              </thead>
              <tbody>
                {data?.items?.length > 0 ? (
                  data?.items.map((item, index) => (
                    <tr key={index}>
                      <td className="text-center align-middle">
                        {(data.pageNo - 1) * data.pageSize + index + 1}
                      </td>
                      <td className="fw-bold align-middle text-center">
                        {item.biltyNumber || "-"}
                      </td>
                      <td className="fw-bold align-middle text-center">
                        {item.createdAt || "-"}
                      </td>
                      <td className="fw-bold align-middle text-cemter">
                        {item.vehicleNumber || "-"}
                      </td>
                      <td className="fw-bold align-middle text-center">
                        {item.consignorAddress || "-"}
                      </td>
                      <td className="fw-bold align-middle text-center">
                        {item.consigneeAddress || "-"}
                      </td>
                      <td className="fw-bold align-middle text-center">
                        {item.consignorName || "-"}
                      </td>
                      <td className="fw-bold align-middle text-center">
                        {item.consigneeName || "-"}
                      </td>
                      <td className="fw-bold align-middle text-center">
                        {item.basicFreight || "-"}
                      </td>
                      <td className="fw-bold align-middle text-center">
                        {"-"}
                      </td>
                      <td className="text-end align-middle">
                        <ActionMenu
                          index={index}
                          actions={[
                            { label: "Edit", icon : <FontAwesomeIcon icon={faEdit}/>, onClick: () => {
                              setBiltyEdit(item.id);
                              setAddBiltyModel(true);
                            } },
                            // ✅ Conditional Actions
                            ...(item.isBiltyGenrated && item.biltyPath
                              ? [
                                  {
                                    label: "Download Bilty",
                                    icon : <FontAwesomeIcon icon={faFilePdf}/>,
                                    onClick: () => window.open(item.biltyPath, "_blank"),
                                  },
                                ]
                              : [
                                  {
                                    label:"Preview",
                                    icon : <FontAwesomeIcon icon={faEye}/>,
                                    onClick: () => GenerateBilty(item.id),
                                  },
                                  {
                                    label: "Generate PDF",
                                    icon : <FontAwesomeIcon icon={faFilePdf}/>,
                                    onClick: () => GenerateBilty(item.id, false),
                                    disabled: isSubmittingBtn,
                                  },
                                ]),
                            { label: "Cancel Bilty", icon : <FontAwesomeIcon icon={faXmark}/>, color:"text-danger", onClick: () => console.log("View", item.id) },
                          ]}
                        />


                        {/* {item.isBiltyGenrated && item.biltyPath != null ? (
                          <a href={item?.biltyPath} target="_blank"
                            className="btn-sm btn btn-primary"
                          >
                            View Bilty
                          </a>
                        ) : (
                          <>
                            <Button
                              disabled={isSubmittingBtn}
                              variant="primary"
                              className="btn-sm me-2 d-flex"
                              onClick={() => GenerateBilty(item.id)}
                            >
                              {processingID == item.id ? (
                                <Spinner
                                className="mx-3"
                                  as="div"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                />
                              ) : "Preview"}
                            </Button>
                            <Button
                              disabled={isSubmittingBtn}
                              variant="success"
                              className="btn-sm"
                              onClick={() => GenerateBilty(item.id, false)}
                            >
                              Generate Bilty
                            </Button>
                          </>
                        )} */}

                        {/* <Button onClick={handleDelete} variant="danger" className="btn-sm">Remove</Button> */}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="11" className="text-center">
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
          <div className="d-flex justify-content-end">
            <CustomPagination
              totalPages={data.totalPage}
              loading={dataLoading}
              onPageChange={handlePageChange}
            />
          </div>
        </Card.Body>
      </Card>
    </>
  );
};
